<template>
  <div class="linksContainer">
    <template v-if="general">
      <component
        v-for="link in general.footer_links"
        :is="link.is_external ? 'a' : 'RouterLink'"
        v-bind="linkdata(link)"
      >
        {{ linktext(link) }}
      </component>
    </template>

    <ConsentModalToggle class="desktop" />
  </div>
</template>

<script>
import ConsentModalToggle from '../general/ConsentModalToggle.vue';
export default {
  components: { ConsentModalToggle },
  methods: {
    linkdata(link) {
      if (link.is_external) {
        return {
          href: link.link_url
        };
      } else {
        return {
          to: link.page_ref.url
        };
      }
    },
    linktext(link) {
      if (link.is_external) {
        return link.link_text;
      } else {
        return link.page_ref.title;
      }
    }
  }
};
</script>
<style scoped lang="scss">
@media screen and (max-width: $breakpoint) {
  .desktop {
    // display: none;
  }
}
</style>
